import { Spin } from 'antd'
import type { NoyoGroupPlan } from 'enrollment-platform/api/partner-benefit-graph/noyo-differences.types'
import React from 'react'
import { PlanLabel } from './PlanLabel'

type SureCoPlanCellProps = {
  plan?: NoyoGroupPlan
  loading?: boolean
  highlightStart?: boolean
  highlightEnd?: boolean
}

export function SureCoPlanCell({
  plan,
  loading,
  highlightStart,
  highlightEnd,
}: SureCoPlanCellProps) {
  if (plan != null && plan.name.length > 0) {
    return (
      <PlanLabel
        plan={plan}
        highlightStart={highlightStart}
        highlightEnd={highlightEnd}
      />
    )
  }
  if (loading === true) {
    return <Spin size="small" />
  }
  return <span>—</span>
}
